module.exports = __webpack_public_path__ + "img/gateway.ec0d10f3.svg";